import { FC } from 'react';
import {
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  NumberInput,
  NumberInputField,
  Select,
} from '@chakra-ui/react';
import { AdTemplateDisplayOptions } from '@adflow/types';
import { currencies } from '@adflow/utils';

type OddsFormatProps = {
  oddsDisplayOptions: AdTemplateDisplayOptions['odds'] | null | undefined;
  handleChangeOddsFormat: React.ChangeEventHandler<HTMLSelectElement>;
  setOddsStakeAmount: React.ChangeEventHandler<HTMLInputElement>;
  setOddsStakeCurrency: React.ChangeEventHandler<HTMLSelectElement>;
  setCalculateDecimalPlaces: (isChecked: boolean) => void;
};

const OddsFormat: FC<OddsFormatProps> = ({
  oddsDisplayOptions,
  handleChangeOddsFormat,
  setOddsStakeAmount,
  setOddsStakeCurrency,
  setCalculateDecimalPlaces,
}) => {
  return (
    <>
      <Divider />
      <Heading size="sm">Odds Format</Heading>
      <Select
        data-test-id="odds-display"
        placeholder="Select Odds Format"
        value={oddsDisplayOptions?.type ?? ''}
        onChange={handleChangeOddsFormat}
      >
        <option value="fractionalOdds">Fractional</option>
        <option value="decimalOdds">Decimal</option>
        <option value="europeanDecimalOdds">European Decimal</option>
        <option value="americanOdds">American</option>
        <option value="potentialWinnings">Potential winnings</option>
      </Select>
      {oddsDisplayOptions?.type === 'potentialWinnings' ? (
        <Flex direction="column" gap="3">
          <Flex flexDirection="row" gap="3">
            <FormControl flex="1">
              <FormLabel>Stake</FormLabel>
              <NumberInput min={1} value={oddsDisplayOptions.stake ?? ''}>
                <NumberInputField onChange={setOddsStakeAmount} data-test-id="stake-amount-input" />
              </NumberInput>
            </FormControl>
            <FormControl flex="1">
              <FormLabel>Currency</FormLabel>
              <Select
                data-test-id="currency-select"
                value={oddsDisplayOptions.currency ?? ''}
                onChange={setOddsStakeCurrency}
              >
                {currencies.map((currency) => (
                  <option key={currency.name} value={currency.value}>
                    {currency.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Flex>
          <FormControl>
            <Checkbox
              isChecked={oddsDisplayOptions?.calculateDecimalPlaces ?? false}
              onChange={(e) => {
                setCalculateDecimalPlaces(e.target.checked);
              }}
            >
              Display decimal places
            </Checkbox>
          </FormControl>
        </Flex>
      ) : null}
    </>
  );
};

OddsFormat.displayName = 'OddsFormat';

export default OddsFormat;
